export const SIDE_NAV_COLLAPSED_STORAGE_KEY = "wcrm.sideNavCollapsed";

export function parseSideNavCollapsed(value: string | null | undefined): boolean {
  if (value === "false" || value === "0") return false;
  return true;
}

export function nextSideNavCollapsed(collapsed: boolean): boolean {
  return !collapsed;
}

export function sideNavClassName(collapsed: boolean): string {
  return collapsed ? "side-nav is-collapsed" : "side-nav";
}
